import React, { useState, useRef, useEffect, useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { AppContext } from '../../App';
import getCountriesBoundingBox from './countryBounds';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import './tripPlanTree.css';
import TripPlanTreeTutorialModal from './TripPlanTreeTutorialModal';
import EventMediaModal from './EventMediaModal';
import RouteDialog from './RouteDialog';
import TreeEvent from './TreeEvent';
import { EVENT_TYPES } from './eventTypeIcons'; // Import EVENT_TYPES for consistency

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Helper to generate the correct backend URL for event media
function getEventMediaUrl(event) {
  if (!event || !event.media) return '';
  // Use event._id if present, else event.eventID
  const eventId = event._id;
  // event.media is the filename
  return `${BACKEND_URL}/uploads/${eventId}/${encodeURIComponent(event.media)}`;
}

function TreeDay({ day, onAddEvent, dayIdx, setEditingEvent,  onMapIconClick, onEditDay, onDeleteDay, onEditEvent, onDeleteEvent, editingEvent, onEditEventSave, 
  onEditEventCancel, onEditMapPicker, setNewEventForDay, newEvent, onAttachDocument, onEventDoubleClick, attachedFile, selectedEventIdx, isSelected, 
  onSelectDay, onSelectEvent, userLayer, fixedDates ,setNewEvent,setNewEventDayIdx, editingDayIdx, editingDayValue, setEditingDayValue, onEditDaySave, 
  onEditDayCancel, setEventEditMode,trip , onAttachView, isOwner, isMultiSelectMode, selectedEvents, clearRoutesAndMultiSelection, isMobile, 
  folderDragHandleProps, isFolderDraggable  }) {
  const [expanded, setExpanded] = useState(true);
  const [showAdd, setShowAdd] = useState(false);
  const [hovered, setHovered] = useState(false);
 
  // Always use the correct newEvent for this day
  const currentNewEvent = newEvent || { _id: '', eventType: 'Location', description: '', longDescription:'',location: { name: '', lat: null, lng: null } };

  const handleAddEvent = React.useCallback(() => {
    const desc = currentNewEvent.description || currentNewEvent.location?.name || '';
    onAddEvent(dayIdx, { ...currentNewEvent });
    setEditingEvent({ dayIdx : null, eventIdx:null });
     setEventEditMode(null);
    setNewEvent({ _id: '', eventType: EVENT_TYPES[0], description: '', longDescription: '' , location: { name: '', lat: null, lng: null } });
    setNewEventDayIdx(null);
    setShowAdd(false);
  }, [currentNewEvent, onAddEvent, dayIdx, setEditingEvent, setNewEventForDay]);

  return (
    <div className={"tree-day" + (isSelected ? " selected" : "")}
      onClick={e => { e.stopPropagation(); if (onSelectDay) onSelectDay(); }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <div  className="tree-node">
        <span
          className="tree-folder-icon"
          onClick={e => { e.stopPropagation(); setExpanded(exp => !exp); }}
        >
          {expanded ? '▼' : '▶'}
        </span>
        <span
          className={`tree-folder-drag-handle${isFolderDraggable ? '' : ' disabled'}`}
          title={isFolderDraggable ? 'Drag to reorder day' : 'Select day to drag'}
          {...(isFolderDraggable && folderDragHandleProps ? folderDragHandleProps : {})}
        >
          ⠿
        </span>
        {/* Only expand/collapse on icon click, not on label click */}
        <span
          className={`tree-day-label${editingDayIdx === dayIdx ? ' editing' : ''}`}
          onClick={e => { e.stopPropagation(); if (onSelectDay) onSelectDay(); }}
        >
          {editingDayIdx === dayIdx ? (
            <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
              <div style={{ flex: 1, display: 'flex', alignItems: 'center', gap: 1 }}>
                {fixedDates && (
                  <input
                    type="date"
                    className="tree-day-edit-date-input"
                    value={editingDayValue.date}
                    onChange={e => setEditingDayValue(val => ({ ...val, date: e.target.value }))}
                  />
                )}
                <input
                  className="tree-day-edit-input"
                  value={editingDayValue.description}
                  onChange={e => setEditingDayValue(val => ({ ...val, description: e.target.value }))}
                  onKeyDown={e => {
                    if (e.key === 'Enter') onEditDaySave(dayIdx);
                    if (e.key === 'Escape') onEditDayCancel();
                  }}
                  autoFocus
                />
              </div>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <button
                  id="saveEditDayBtn"
                  className="tree-day-edits-btn mini-btn"
                  title="Save"
                  onClick={e => { e.stopPropagation(); onEditDaySave(dayIdx); }}
                >✔</button>
                <button
                  className="tree-day-edits-btn mini-btn"
                  title="Cancel"
                  onClick={e => { e.stopPropagation(); onEditDayCancel(); }}
                >✖</button>
              </div>
            </div>
          ) : (
            fixedDates
              ? `${new Date(day.date).toLocaleDateString()} - ${day.description}`
              : day.description
          )}
        </span>
{editingDayIdx !== dayIdx && (
  <>
    {isOwner && <button className="tree-edit-btn mini-btn" title="Edit Day" onClick={e => { e.stopPropagation(); onEditDay(dayIdx); }}>✎</button>}
    {isOwner && <button className="tree-delete-btn mini-btn" title="Delete Day" onClick={e => { e.stopPropagation(); onDeleteDay && onDeleteDay(); }}>🗑</button>}
    {hovered && isOwner && (
      <button id="addEventBtn" className="tree-add-btn mini-btn" title="Add Event" onClick={e => {
        e.stopPropagation();
        clearRoutesAndMultiSelection(); // Clear routes when adding event
        setShowAdd(s => !s);
        setEventEditMode('add');
        setEditingEvent({ dayIdx, eventIdx: day.events.length });
      }}>＋</button>
    )}
  </>
)}
      </div>
      {showAdd && (
        <TreeEvent
          event={currentNewEvent}
          isEditing={false}
          showAddMode={true}
          onEditLongDescription={val => setNewEvent && setNewEvent({ ...currentNewEvent, longDescription: val })}
          onEditChange={val => setNewEvent && setNewEvent({ ...currentNewEvent, description: val })}
          onEditTypeChange={val => setNewEvent && setNewEvent({ ...currentNewEvent, eventType: val })}
          onEditSave={handleAddEvent}
          onEditCancel={() => {setShowAdd(false) ; setEventEditMode(null); setEditingEvent({ dayIdx: null, eventIdx: null });}}
          onEditMapPicker={desc => onMapIconClick && onMapIconClick(desc, undefined, undefined, undefined, true)}
          onAttachDocument={onAttachDocument ? onAttachDocument(day.events.length) : undefined}
          attachedFile={showAdd ? attachedFile : undefined}
          editingLocation={currentNewEvent.location}
          trip={trip}
          isOwner={isOwner}
          isMultiSelectMode={isMultiSelectMode}
          isSelectedRouteEvent={false} // Add mode is never a selected route event
        />
      )}
      {expanded && (
        <div className="tree-children">
          <Droppable droppableId={`day-${dayIdx}`} isDropDisabled={!isOwner}>
            {(provided, snapshot) => (
              <div
                ref={provided.innerRef}
                {...provided.droppableProps}
                className={`droppable-area ${snapshot.isDraggingOver ? 'dragging-over' : ''}`}
              >
                {day.events
                  .slice()
                  .sort((a, b) => (a.orderInDay || 1) - (b.orderInDay || 1))
                  .map((event, idx) => {
                    // Find the original index in the unsorted array for callbacks
                    const originalIdx = day.events.findIndex(e => e._id === event._id);
                    return (
                      <Draggable 
                        key={event._id || `event-${dayIdx}-${idx}`}
                        draggableId={`event-${dayIdx}-${originalIdx}-${event._id}`}
                        index={idx}
                        isDragDisabled={!isOwner || (editingEvent && editingEvent.dayIdx === dayIdx && editingEvent.eventIdx === originalIdx)}
                      >
                        {(provided, snapshot) => {
                          return (
                            <div
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...(!isMobile ? provided.dragHandleProps : {})} // Only add drag handle props on desktop
                              className={`draggable-event ${snapshot.isDragging ? 'dragging' : ''}`}
                              style={{
                                ...provided.draggableProps.style,
                                // Allow normal scrolling on mobile; desktop keeps grab behavior
                                touchAction: isMobile ? 'pan-y' : 'auto',
                                WebkitTouchCallout: isMobile ? 'auto' : 'none',
                                WebkitUserSelect: isMobile ? 'auto' : 'none',
                                userSelect: isMobile ? 'auto' : 'none'
                              }}
                            >
                              {/* Mobile-only drag handle positioned over the CSS ::before icon */}
                              {isMobile && (
                                <div
                                  {...provided.dragHandleProps}
                                  className="mobile-drag-handle"
                                  style={{
                                    position: 'absolute',
                                    left: '2px',
                                    top: '0px',
                                    width: '18px',
                                    height: '100%',
                                    zIndex: 999,
                                    cursor: 'grab',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    touchAction: 'none'
                                  }}
                                >
                                </div>
                              )}
                              <TreeEvent
                              key={event._id || idx}
                              event={
                                editingEvent && editingEvent.dayIdx === dayIdx && editingEvent.eventIdx === originalIdx
                                  ? editingEvent.event
                                  : event
                              }
                              onMapIconClick={onMapIconClick}
                              onEdit={() => onEditEvent(originalIdx)}
                              onDelete={() => onDeleteEvent(originalIdx)}
                              isEditing={editingEvent && editingEvent.dayIdx === dayIdx && editingEvent.eventIdx === originalIdx}
                              onEditChange={val =>
                                setEditingEvent(prev =>
                                  prev && prev.dayIdx === dayIdx && prev.eventIdx === originalIdx
                                    ? { ...prev, event: { ...prev.event, description: val } }
                                    : prev
                                )
                              }
                              onEditLongDescription={val =>
                                setEditingEvent(prev =>
                                  prev && prev.dayIdx === dayIdx && prev.eventIdx === originalIdx
                                    ? { ...prev, event: { ...prev.event, longDescription: val } }
                                    : prev
                                )
                              }
                              onEditTypeChange={val =>
                                setEditingEvent(prev =>
                                  prev && prev.dayIdx === dayIdx && prev.eventIdx === originalIdx
                                    ? { ...prev, event: { ...prev.event, eventType: val } }
                                    : prev
                                )
                              }
                              onEditSave={onEditEventSave}
                              onEditCancel={onEditEventCancel}
                              onEditMapPicker={desc => onEditMapPicker(desc)}
                              onAttachDocument={onAttachDocument ? onAttachDocument(originalIdx) : undefined}
                              onDoubleClick={onEventDoubleClick}
                              onAttachView={onAttachView}
                              attachedFile={editingEvent && editingEvent.dayIdx === dayIdx && editingEvent.eventIdx === originalIdx ? attachedFile : undefined}
                              editingLocation={editingEvent && editingEvent.dayIdx === dayIdx && editingEvent.eventIdx === originalIdx ? editingEvent.event.location : event.location}
                              isSelected={(isSelected && selectedEventIdx === originalIdx) || selectedEvents.has(event._id)}
                              onClick={e => { 
                                e.stopPropagation(); 
                                if (onSelectEvent) onSelectEvent(dayIdx, originalIdx, e.ctrlKey || e.metaKey); 
                              }}
                              userLayer={userLayer}
                              trip={trip}
                              isOwner={isOwner} // Pass to TreeEvent for per-event disables
                              isMultiSelectMode={isMultiSelectMode}
                              isSelectedRouteEvent={
                                // Check if this is the currently selected route event that allows edit/delete in multi-select mode
                                isMultiSelectMode && 
                                isSelected && // This day is selected
                                selectedEventIdx === originalIdx && // This event is selected within the day
                                event.eventType === 'Route'
                              }
                            />
                          </div>
                        );
                        }}
                      </Draggable>
                    );
                  })}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </div>
      )}
    </div>
  );
}


export default function TripPlanTree({ 
  setAddNodeCallback, 
  tripId: propTripId, 
  searchMapCallback, 
  setSearchMapCallback,
  trip, 
  setTrip, 
  selectedDayIdx, 
  setSelectedDayIdx, 
  selectedEventIdx, 
  setSelectedEventIdx, 
  selectedEventID,
  setSelectedEventID,
  editingEvent, 
  setEditingEvent, 
  onRemoveMarkerEvent, 
  onClearSelectedPlace,
  fixedDates,
  loading,
  setLoading,
  newEvents,
  setNewEvents,
  isMultiSelectMode,
  setIsMultiSelectMode,
  selectedEvents,
  setSelectedEvents
}) {
  const location = useLocation();
  const { userCtx } = useContext(AppContext);
  const userLayer = userCtx?.layer || 0;

  const tripFromState = location.state?.trip;
  const tripId = propTripId || tripFromState?._id || tripFromState?.id;

  // --- NEW: Track ownership ---
  const [isOwner, setIsOwner] = useState(true);
  
  // --- Multi-selection state now comes from props ---
  // selectedEvents and isMultiSelectMode are passed as props
  
  // --- NEW: Previous selected event tracking ---
  const [previousSelectedEvent, setPreviousSelectedEvent] = useState(null); // Store the actual event object
  
  // --- NEW: Route dialog state ---
  const [showRouteDialog, setShowRouteDialog] = useState(false);
  const [pendingRoute, setPendingRoute] = useState(null);
  
  // --- NEW: Flag to prevent useEffect race condition when clearing routes ---
  const [isClearing, setIsClearing] = useState(false);
  
  // --- Mobile detection for drag handles ---
  const [isMobile, setIsMobile] = useState(false);
  
  // Detect coarse pointers / narrow viewports so drag handles only appear on touch devices
  useEffect(() => {
    if (typeof window === 'undefined') return;

    const supportsMatchMedia = typeof window.matchMedia === 'function';
    const widthMedia = supportsMatchMedia ? window.matchMedia('(max-width: 600px)') : null;
    const pointerMedia = supportsMatchMedia ? window.matchMedia('(pointer: coarse)') : null;

    const updateMobileFlag = () => {
      const widthMatch = widthMedia ? widthMedia.matches : window.innerWidth <= 600;
      const pointerMatch = pointerMedia ? pointerMedia.matches : false;
      setIsMobile(widthMatch || pointerMatch);
    };

    const subscribe = (mediaQuery) => {
      if (!mediaQuery) return () => {};
      const handler = () => updateMobileFlag();
      if (mediaQuery.addEventListener) {
        mediaQuery.addEventListener('change', handler);
        return () => mediaQuery.removeEventListener('change', handler);
      }
      if (mediaQuery.addListener) {
        mediaQuery.addListener(handler);
        return () => mediaQuery.removeListener(handler);
      }
      return () => {};
    };

    updateMobileFlag();
    const cleanupWidth = subscribe(widthMedia);
    const cleanupPointer = subscribe(pointerMedia);
    window.addEventListener('resize', updateMobileFlag);

    return () => {
      cleanupWidth && cleanupWidth();
      cleanupPointer && cleanupPointer();
      window.removeEventListener('resize', updateMobileFlag);
    };
  }, []);

  // Helper function to clear routes and multi-selection
  const clearRoutesAndMultiSelection = React.useCallback(() => {
    console.log('🧹 Clearing routes and multi-selection due to edit/add mode');
    
    // Clear multi-selection state
    setSelectedEvents(new Set());
    setIsMultiSelectMode(false);
    setPreviousSelectedEvent(null);
    
    // Clear any displayed routes
    if (searchMapCallback) {
      searchMapCallback('', null, null, null, false, null);
    }
  }, [setSelectedEvents, setIsMultiSelectMode, searchMapCallback]);

  // ESC key handler to clear multi-selection
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape' && isMultiSelectMode) {
        // Select the first event from multi-selection as single selection
        if (selectedEvents.size > 0) {
          const firstEventId = Array.from(selectedEvents)[0];
          const firstEvent = trip.days.flatMap((day, dIdx) => 
            day.events.map((evt, eIdx) => ({ evt, dIdx, eIdx }))
          ).find(({ evt }) => evt._id === firstEventId);
          
          if (firstEvent) {
            // Set the first event as single selection
            React.startTransition(() => {
              setSelectedDayIdx(firstEvent.dIdx);
              setSelectedEventIdx(firstEvent.eIdx);
            });
            setPreviousSelectedEvent(firstEvent.evt);
          }
        }
        
        // Clear multi-selection mode and indicators
        setSelectedEvents(new Set());
        setIsMultiSelectMode(false);
      }
    };
    
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [isMultiSelectMode, selectedEvents, trip]);

  // Check if current user own the tree (else disable all edit operations)
  useEffect(() => {
    if (!tripId) return;
    // Check ownership on mount
    fetch(`${BACKEND_URL}/check-userownership/${tripId}`, {
      method: 'GET',
      credentials: 'include'
    })
      .then(res => res.json())
      .then(data => {
        setIsOwner(!!data.isOwner);
      })
      .catch(() => setIsOwner(false));
  }, [tripId]);

  const [pendingFileUpload, setPendingFileUpload] = useState(null); // For pending file uploads
  const [expanded, setExpanded] = useState(true);
  const [showAddDay, setShowAddDay] = useState(false);
  const [mediaModal, setMediaModal] = useState({ open: false, url: '', filename: '' });
  // loading is now passed as prop, removed local state
  const [editingDayIdx, setEditingDayIdx] = useState(null);
const [editingDayValue, setEditingDayValue] = useState({ date: '', description: '' });
const [eventEditMode, setEventEditMode] = useState(null); // 'add' | 'edit' | null


const [newDay, setNewDay] = useState(() => {
    return { date: new Date().toISOString().slice(0, 10), description: '' };
}); 
  
  const editingEventRef = React.useRef(editingEvent);
  React.useEffect(() => { editingEventRef.current = editingEvent; }, [editingEvent]);
  // Inline edit state for events
  
  // Restore local state for newEvents, selectedDayIdx, selectedEventIdx, and setNewEventForDay
const [newEvent, setNewEvent] = useState({ _id: '', eventType: 'Location', description: '', location: { name: '', lat: null, lng: null } });
const [newEventDayIdx, setNewEventDayIdx] = useState(null);

 // tripRef remains local state, loading now passed as prop
const tripRef = useRef(trip);
useEffect(() => { tripRef.current = trip; }, [trip]);
const eventEditModeRef = useRef(eventEditMode);
React.useEffect(() => { eventEditModeRef.current = eventEditMode; }, [eventEditMode]);

useEffect(() => {
  if (!pendingFileUpload || !trip) return;
  const { dayIdx, mergedEvent, file } = pendingFileUpload;
  async function uploadAndAttach() {
    try {
      const data = await uploadEventAttachment(mergedEvent._id, file);
      setTrip(prevTrip => {
        const updatedTrip = {
          ...prevTrip,
          days: prevTrip.days.map((day, dIdx) =>
            dIdx === dayIdx
              ? {
                  ...day,
                  events: day.events.map(event =>
                    event._id === mergedEvent._id
                      ? { ...event, attachment: data.attachment || true }
                      : event
                  ),
                }
              : day
          ),
        };
        // Ensure proper sorting after update
        return {
          ...updatedTrip,
          days: updatedTrip.days.map(day => ({
            ...day,
            events: day.events.sort((a, b) => (a.orderInDay || 1) - (b.orderInDay || 1))
          }))
        };
      });
    } catch (err) {
      console.log('Failed to upload document: ' + err.message);
    } finally {
      setAttachedFile('');
      setPendingFileUpload(null);
    }
  }

  uploadAndAttach();
}, [trip, pendingFileUpload]);


  // New: Track attached files for events being added/edited
const [attachedFile, setAttachedFile] = useState(''); // 

// Attach document to event (store file in state, do not upload yet)
function handleAttachDocument(dayIdx, eventIdx) {
  return (file) => {
    if (!file) return;
    setAttachedFile(file);
  };
}

// Helper to upload attachment after event is saved
async function uploadEventAttachment(eventId, file) {
  const formData = new FormData();
  formData.append('file', file);
  const res = await fetch(`${BACKEND_URL}/events/upload/${eventId}`, {
    method: 'POST',
    credentials: 'include',
    body: formData,
  });
  if (!res.ok) throw new Error('Failed to upload document');
  return await res.json();
}

// Updated: Add event and upload attachment if present
const addEventToTrip = React.useCallback(async (dayIdx, event) => {
  const desc = event.description || event.location?.name || '';
  if (!desc) return;
  
  // Calculate the next orderInDay for the new event
  const currentDay = trip.days[dayIdx];
  const maxOrderInDay = currentDay.events.length > 0 
    ? Math.max(...currentDay.events.map(e => e.orderInDay || 0))
    : 0;
  
  const mergedEvent = {
    eventType: event.eventType || 'Location',
    description: desc,
    location: {
      ...event.location, // Spread all location fields
      zoom: event.location?.zoom || 15, // Default zoom if not present
    },
    url: event.url || '',
    media: attachedFile ? attachedFile.name : (event.media || ''),
    longDescription: event.longDescription || '',
    orderInDay: maxOrderInDay + 1, // Set the next order position
    // Add route object if this is a route event
    ...(event.route && { route: event.route })
  };
  try {
    const newTrip = {
      ...trip,
      days: trip.days.map((day, idx) => {
        if (idx === dayIdx) {
          const newEvents = [...day.events, mergedEvent];
          // Sort events by orderInDay to maintain proper order
          newEvents.sort((a, b) => (a.orderInDay || 1) - (b.orderInDay || 1));
          return {
            ...day,
            events: newEvents
          };
        }
        return day;
      })
    };
    const updatedTrip = await updateTripOnBackend(newTrip);
    // Ensure the returned trip data is properly sorted
    const sortedTrip = {
      ...updatedTrip,
      days: updatedTrip.days.map(day => ({
        ...day,
        events: day.events.sort((a, b) => (a.orderInDay || 1) - (b.orderInDay || 1))
      }))
    };
    setTrip(sortedTrip);
    setSelectedDayIdx(dayIdx);
    let backendDay = sortedTrip.days[dayIdx];
    if (backendDay && backendDay.events) {
      // Find the newly added event by its _id or description to get correct index after sorting
      const newEventIndex = backendDay.events.findIndex(e => 
        e.description === desc && e.orderInDay === (maxOrderInDay + 1)
      );
      setSelectedEventIdx(newEventIndex >= 0 ? newEventIndex : backendDay.events.length - 1);
      let backendEvent = backendDay.events[newEventIndex >= 0 ? newEventIndex : backendDay.events.length - 1];
      if (attachedFile && backendEvent) {
        backendEvent.media = attachedFile.name;
        setPendingFileUpload({ dayIdx, mergedEvent: backendEvent, file: attachedFile });
      }
    }
  } catch (err) {
    console.log('Failed to add event: ' + err.message);
  }
  
}, [attachedFile, trip, updateTripOnBackend]);

// Add refs for selectedDayIdx and addEventToTrip
const selectedDayIdxRef = React.useRef(selectedDayIdx);
const addEventToTripRef = React.useRef(addEventToTrip);
React.useEffect(() => { selectedDayIdxRef.current = selectedDayIdx; }, [selectedDayIdx]);
React.useEffect(() => { addEventToTripRef.current = addEventToTrip; }, [addEventToTrip]);
useEffect(() => {
  if (setAddNodeCallback) {
    setAddNodeCallback(() => setMapLocationCB);
  }
}, [setAddNodeCallback]);

// Updated callback when user pick location on the map support add & edit mode : always use latest state from refs
const setMapLocationCB = React.useCallback((name, lat, lng, zoom, rating, user_ratings_total, url, formatted_address, formatted_phone_number, place_id) => {
  const editingEventCurrent = editingEventRef.current;
  const selectedDayIdx = selectedDayIdxRef.current;
  const trip = tripRef.current;
  const addEventToTrip = addEventToTripRef.current;
  const mode = eventEditModeRef.current; // <-- Use ref

  if (mode === 'add' && editingEventCurrent && editingEventCurrent.dayIdx != null) {
    setNewEvent({
      ...newEvent,
      description: name, // Enhancment : should also include long description 
      location: { name, lat, lng, zoom, rating, user_ratings_total, url, formatted_address, formatted_phone_number, place_id }
    });
    setNewEventDayIdx(editingEventCurrent.dayIdx);
    return;
  }
  if (mode === 'edit' && editingEventCurrent && editingEventCurrent.dayIdx != null && editingEventCurrent.eventIdx != null) {
    setEditingEvent(prev =>
      prev && prev.dayIdx === editingEventCurrent.dayIdx && prev.eventIdx === editingEventCurrent.eventIdx
        ? {
            ...prev,
            event: {
              ...prev.event,
              description: name,
              location: { name, lat, lng, zoom, rating, user_ratings_total, url, formatted_address, formatted_phone_number, place_id },
              media: attachedFile ? attachedFile.name : prev.event.media,
            }
          }
        : prev
    );
    setNewEventDayIdx(editingEventCurrent.dayIdx);
    return;
  }

  // Quick add from map (outside inline add/edit)
  if (selectedDayIdx != null && trip && trip.days && trip.days[selectedDayIdx]) {
    const newEventObj = {
      eventType: 'Location',
      description: name,
      location: { name, lat, lng, zoom, rating, user_ratings_total, url, formatted_address, formatted_phone_number, place_id }
    };
    addEventToTrip(selectedDayIdx, newEventObj);
  }
}, [newEvent, setNewEvent, setNewEventDayIdx, setTrip, setEditingEvent,eventEditModeRef]);



  // When the map icon is clicked, call the searchMapCallback from props
  const handleMapIconClick = (desc,lat,lng,zoom,search) => {
    if (searchMapCallback) searchMapCallback(desc,lat,lng,zoom,search);
  };

  // Load trip from backend on mount
  React.useEffect(() => {
    if (!tripId) return;
    setLoading(true);
    fetch(`${BACKEND_URL}/newtrips/${tripId}`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
    })
      .then(res => {
        if (!res.ok) throw new Error('Failed to fetch trip');
        return res.json();
      })
      .then(data => {
        // Process each day to ensure events are ordered by orderInDay
        const processedTrip = {
          ...data,
          days: data.days.map(day => ({
            ...day,
            events: day.events
              .map((event, index) => ({
                ...event,
                // Backward compatibility: if orderInDay is missing or 0, assign default order
                orderInDay: (event.orderInDay && event.orderInDay > 0) ? event.orderInDay : index + 1
              }))
              .sort((a, b) => (a.orderInDay || 1) - (b.orderInDay || 1)) // Sort by orderInDay consistently
          }))
        };
        setTrip(processedTrip);
        
        // Auto-select first day on initial load if trip has days
        if (processedTrip.days && processedTrip.days.length > 0) {
          setSelectedDayIdx(0);
          setSelectedEventIdx(null);
        }
        
        setLoading(false);
      })
      .catch(err => {
        console.error('Error loading trip from backend:', err);
        setLoading(false);
      });
  }, [tripId]);

  // Add edit/delete handlers for days and events
  function handleEditDay(dayIdx) {
  // Clear multi-selection and routes when editing
  clearRoutesAndMultiSelection();
  
  const rawDate = trip.days[dayIdx].date || '';
  // Ensure date is in YYYY-MM-DD format
  const formattedDate = rawDate ? new Date(rawDate).toISOString().slice(0, 10) : '';
  setEditingDayIdx(dayIdx);
  setEditingDayValue({
    date: formattedDate,
    description: trip.days[dayIdx].description || ''
  });
}

  function handleEditDaySave(dayIdx) {
  const { date, description } = editingDayValue;
  if (
    (description !== null && description !== trip.days[dayIdx].description) ||
    (date !== trip.days[dayIdx].date)
  ) {
    const days = trip.days.map((d, idx) =>
      idx === dayIdx
        ? { ...d, description, ... { date } }
        : d
    );
    const updatedTrip = { 
      ...trip, 
      days: days.map(day => ({
        ...day,
        events: day.events.sort((a, b) => (a.orderInDay || 1) - (b.orderInDay || 1))
      }))
    };
    setTrip(updatedTrip);
    updateTripOnBackend(updatedTrip);
  }
  setEditingDayIdx(null);
  setEditingDayValue({ date: '', description: '' });
}

function handleEditDayCancel() {
  setEditingDayIdx(null);
  setEditingDayValue({ date: '', description: '' });
}

  function handleDeleteDay(dayIdx) {
    if (window.confirm('Delete this day and all its events?')) {
      const days = trip.days.filter((_, idx) => idx !== dayIdx);
      const updatedTrip = { 
        ...trip, 
        days: days.map(day => ({
          ...day,
          events: day.events.sort((a, b) => (a.orderInDay || 1) - (b.orderInDay || 1))
        }))
      };
      setTrip(updatedTrip);
      updateTripOnBackend(updatedTrip);
    }
  }

  function handleEditEvent(dayIdx, eventIdx) {
    // Clear multi-selection and routes when editing
    clearRoutesAndMultiSelection();
    setEventEditMode('edit');
    const event = trip.days[dayIdx].events[eventIdx];
    setEditingEvent({
      dayIdx,
      eventIdx,
      event: { ...event } // deep copy if needed
    });
    // Batch the state updates to prevent double useEffect triggers
    React.startTransition(() => {
      setSelectedDayIdx(dayIdx);
      setSelectedEventIdx(eventIdx);
    });
  }
  function handleDeleteEvent(dayIdx, eventIdx) {
    const eventToDelete = trip.days[dayIdx].events[eventIdx];
    
    // Check if this is a route event and store connected event info before deletion
    let firstConnectedEvent = null;
    if (eventToDelete.eventType === 'Route' && eventToDelete.route && eventToDelete.route.eventIds && eventToDelete.route.eventIds.length > 0) {
      console.log('🛣️ Deleting route event, will select first connected event:', eventToDelete.route.eventIds[0]);
      
      // Find the first connected event in the trip
      const firstEventId = eventToDelete.route.eventIds[0];
      for (let dIdx = 0; dIdx < trip.days.length; dIdx++) {
        const day = trip.days[dIdx];
        for (let eIdx = 0; eIdx < day.events.length; eIdx++) {
          const event = day.events[eIdx];
          if (event._id === firstEventId) {
            firstConnectedEvent = { dayIdx: dIdx, eventIdx: eIdx, event };
            break;
          }
        }
        if (firstConnectedEvent) break;
      }
    }
    
    setTrip(trip => {
      const days = trip.days.map((d, dIdx) =>
        dIdx === dayIdx
          ? { 
              ...d, 
              events: d.events
                .filter(event => event._id !== eventToDelete._id) // Filter by _id instead of index
                // Keep original orderInDay values - don't renumber!
                .sort((a, b) => (a.orderInDay || 1) - (b.orderInDay || 1)) // Ensure proper order
            }
          : d
      );
      const updatedTrip = { ...trip, days };
      updateTripOnBackend(updatedTrip);
      return updatedTrip;
    });
    
    // Handle route event deletion aftermath
    if (eventToDelete.eventType === 'Route') {
      console.log('🧹 Clearing route from map after route event deletion');
      
      // Clear the route from the map
      if (searchMapCallback) {
        searchMapCallback('', null, null, null, false, null);
      }
      
      // Clear multi-selection mode if we were in it
      setIsMultiSelectMode(false);
      setSelectedEvents(new Set());
      setPreviousSelectedEvent(null);
      
      // Select the first connected event if found
      if (firstConnectedEvent) {
        console.log('📍 Selecting first connected event after route deletion:', firstConnectedEvent.event.description);
        React.startTransition(() => {
          setSelectedDayIdx(firstConnectedEvent.dayIdx);
          setSelectedEventIdx(firstConnectedEvent.eventIdx);
        });
        setPreviousSelectedEvent(firstConnectedEvent.event);
      } else {
        // No connected event found, clear selection
        React.startTransition(() => {
          setSelectedDayIdx(null);
          setSelectedEventIdx(null);
        });
      }
    }

    // Call myMap to clear selected place to close InfoWindow
    if (onClearSelectedPlace ) {
      onClearSelectedPlace();
    } 

    setEditingEvent({ dayIdx: null, eventIdx: null });
    
  }
  async function handleEditEventSave() {
    setEventEditMode(null);
    const { dayIdx, eventIdx, event } = editingEvent;
    // Use attachedFile if present, otherwise keep existing media
    const updateMedia = attachedFile ? attachedFile.name : event.media;
    
    // Get the original event to preserve orderInDay
    const originalEvent = trip.days[dayIdx].events[eventIdx];

    const newTrip = {
      ...trip,
      days: trip.days.map((d, dIdx) => {
        if (dIdx === dayIdx) {
          const updatedEvents = d.events.map((ev, eIdx) =>
            eIdx === eventIdx
              ? { 
                  ...ev, 
                  ...event, 
                  media: updateMedia,
                  orderInDay: originalEvent.orderInDay || (eIdx + 1) // Preserve original orderInDay or fallback
                }
              : ev
          );
          // Sort events by orderInDay to maintain proper order
          updatedEvents.sort((a, b) => (a.orderInDay || 1) - (b.orderInDay || 1));
          return {
            ...d,
            events: updatedEvents
          };
        }
        return d;
      })
    };

    try {
      const updatedTrip = await updateTripOnBackend(newTrip);
      // Ensure the returned trip data is properly sorted
      const sortedTrip = {
        ...updatedTrip,
        days: updatedTrip.days.map(day => ({
          ...day,
          events: day.events.sort((a, b) => (a.orderInDay || 1) - (b.orderInDay || 1))
        }))
      };
      setTrip(sortedTrip);

      // Remove the editing marker by clearing editingEvent
      setEditingEvent({ dayIdx: null, eventIdx: null });

      // The map will now render the marker at the new location from updatedTrip

      // Find the updated event in the backend response (by index)
      const backendDay = sortedTrip.days[dayIdx];
      let backendEvent = null;
      if (backendDay && backendDay.events) {
        backendEvent = backendDay.events[eventIdx];
      }
      // Only now, trigger file upload if needed
      if (attachedFile && backendEvent && backendEvent._id) {
        backendEvent.media = attachedFile.name; // Ensure media is set for upload
        setPendingFileUpload({ dayIdx, mergedEvent: backendEvent, file: attachedFile });
      }
    } catch (err) {
      console.log('Failed to edit event: ' + err.message);
    }
    setAttachedFile('');
    // setEditingEvent({ dayIdx: null, eventIdx: null }); // already done above
  }
  
  function handleEditEventCancel() {
    setEventEditMode(null);
    setEditingEvent(null);
  }

  function handleEditMapPicker(desc) {
    if (searchMapCallback) searchMapCallback(desc, undefined, undefined, undefined, true);
  }

  const [showTutorial, setShowTutorial] = useState(() => {
    // Only show if not dismissed before
    return localStorage.getItem('hideTripPlanTreeTutorial') !== 'true';
  });
const [dontShowChecked, setDontShowChecked] = useState(() => {
      return localStorage.getItem('hideTripPlanTreeTutorial') === 'true';
  });

// Persistent selection state for days and events

// Handle selection change to show route for route events
useEffect(() => {
  // Skip map updates when in multi-select mode, UNLESS we have a route event selected
  // that should display its route
  const hasRouteEventSelected = selectedDayIdx !== null && selectedEventIdx !== null && 
    trip && trip.days && trip.days[selectedDayIdx] && 
    trip.days[selectedDayIdx].events[selectedEventIdx] &&
    trip.days[selectedDayIdx].events[selectedEventIdx].eventType === 'Route';
    
  if (isMultiSelectMode && !hasRouteEventSelected) {
    console.log('🔍 Skipping map update - in multi-select mode without route event');
    return;
  }
  
  // Skip map updates when we're in the process of clearing routes to prevent race condition
  if (isClearing) {
    console.log('🔍 Skipping map update - currently clearing routes');
    return;
  }
  
  console.log('🔍 Event selection useEffect triggered - selectedDayIdx:', selectedDayIdx, 'selectedEventIdx:', selectedEventIdx, 'hasRouteEvent:', hasRouteEventSelected, 'Timestamp:', Date.now());
  if (selectedDayIdx !== null && selectedEventIdx !== null && trip && trip.days && trip.days[selectedDayIdx]) {
    const selectedEvent = trip.days[selectedDayIdx].events[selectedEventIdx];
    if (selectedEvent && selectedEvent.eventType === 'Route' && selectedEvent.route && selectedEvent.route.waypoints) {
        console.log('🛣️ Route event selected with waypoints:', selectedEvent.route.waypoints);
      // Show route on map for route events
      if (searchMapCallback) {
          console.log('🛣️ Calling searchMapCallback with waypoints for route display');
        searchMapCallback('', null, null, null, false, selectedEvent.route.waypoints);
      }
    } 
  } else {
    // No event selected, clear routes and show trip overview
    if (searchMapCallback && trip && trip.countries && trip.countries.length > 0) {
      (async () => {
        const boundsOrCenter = await getCountriesBoundingBox(trip.countries, trip.cities);
        if (boundsOrCenter) {
          if (boundsOrCenter.bounds) {
            searchMapCallback('', boundsOrCenter.bounds, null, null, false, null);
          } else {
            searchMapCallback('', boundsOrCenter.lat, boundsOrCenter.lng, boundsOrCenter.zoom, false, null);
          }
        }
      })();
    }
  }
}, [selectedDayIdx, selectedEventIdx, trip, isMultiSelectMode, isClearing]); // Added isClearing to dependencies

const handleCloseTutorial = () => {
    if (dontShowChecked) {
      localStorage.setItem('hideTripPlanTreeTutorial', 'true');
    } else {
      localStorage.removeItem('hideTripPlanTreeTutorial');
    }
    setShowTutorial(false);
  };

  // Explicit function to update trip on backend
  async function updateTripOnBackend(trip) {
    const tripId = trip.id || trip._id || 'default'; // fallback if no id
    const res = await fetch(`${BACKEND_URL}/newtrips/${tripId}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include', // Include cookies
      body: JSON.stringify(trip),
    });
       if (!res.ok) throw new Error('Failed to update trip');
      return await res.json(); 
      
      }
      
  

  const handleAddDay = () => {
    if (!newDay.description) return;
    setTrip(trip => {
      // If fixedDates is true, do not include date field when adding a new day
      const dayToAdd = !trip.fixedDates
        ? { description: newDay.description, events: [] }
        : { date: newDay.date, description: newDay.description, events: [] };

      const days = [...trip.days, dayToAdd];

      // Compute next default date (only if fixedDates is true)
      let nextDate = new Date(newDay.date);
      if (trip.fixedDates) {
        nextDate.setDate(nextDate.getDate() + 1);
      }
      setNewDay({
        date: nextDate.toISOString().slice(0, 10),
        description: ''
      });

      const updatedTrip = { 
        ...trip, 
        days: days.map(day => ({
          ...day,
          events: day.events.sort((a, b) => (a.orderInDay || 1) - (b.orderInDay || 1))
        }))
      };
      updateTripOnBackend(updatedTrip);
      return updatedTrip;
    });
    setShowAddDay(false);
  };

  

  // Guard: don't render until trip is loaded
  if (loading || !trip) {
    return <div className="trip-tree-root"><div>Loading...</div></div>;
  }

  function handleEventSelection(dayIdx, eventIdx, isCtrlClick = false) {
    const event = trip.days[dayIdx].events[eventIdx];
    const eventId = event._id;
    
    // Prevent multi-selecting route events
    if (isCtrlClick && event.eventType === 'Route') {
      return; // Don't allow route events in multi-select
    }
    
    // Store previous selection before changing in single selection mode

  
    
    if (isCtrlClick) {
      // Multi-selection mode
      // if we are in the scenario of moving from single to multi-select mode than add the previous event that was selected
      if (!isMultiSelectMode && previousSelectedEvent && previousSelectedEvent._id) {
        setSelectedEvents(prev => new Set(prev).add(previousSelectedEvent._id));
      }
      setIsMultiSelectMode(true);
      setSelectedEvents(prev => {
        const newSelected = new Set(prev);
        if (newSelected.has(eventId)) {
          newSelected.delete(eventId);
        } else {
          newSelected.add(eventId);
        }
        
        // If only one or no events selected, exit multi-select mode
        if (newSelected.size <= 1) {
          setIsMultiSelectMode(false);
          setPreviousSelectedEvent(null);
          if (newSelected.size === 1) {
            // Set single selection
            const remainingEventId = Array.from(newSelected)[0];
            const remainingEvent = trip.days.flatMap((day, dIdx) => 
              day.events.map((evt, eIdx) => ({ evt, dIdx, eIdx }))
            ).find(({ evt }) => evt._id === remainingEventId);
            
            if (remainingEvent) {
              React.startTransition(() => {
                setSelectedDayIdx(remainingEvent.dIdx);
                setSelectedEventIdx(remainingEvent.eIdx);
              });
            }
          } else {
            React.startTransition(() => {
              setSelectedDayIdx(null);
              setSelectedEventIdx(null);
            });
          }
        }
        
        return newSelected;
      });
    } else {
      // Single selection mode
      if (
        editingEvent &&
        (editingEvent.dayIdx !== dayIdx || editingEvent.eventIdx !== eventIdx)
      ) {
        handleEditEventCancel();
      }
      if (editingDayIdx !== null) {
        handleEditDayCancel();
      }
      
      // Check if this is a route event and auto-select connected events
      if (event.eventType === 'Route' && event.route && event.route.eventIds && event.route.eventIds.length > 0) {
        console.log('🛣️ Route event selected, auto-selecting connected events:', event.route.eventIds);
        
        // Clear any existing route first (in case switching between route events)
        if (searchMapCallback) {
          searchMapCallback('', null, null, null, false, null); // Clear existing route
        }
        
        // Enter multi-selection mode and select only the connected events (NOT the route event itself)
        setIsMultiSelectMode(true);
        const connectedEventIds = new Set(event.route.eventIds); // Only include connected event IDs
        setSelectedEvents(connectedEventIds);
        setPreviousSelectedEvent(null); // Clear previous selection since we're in multi-select mode
        
        // Keep the route event as single selection for UI purposes
        React.startTransition(() => {
          setSelectedDayIdx(dayIdx);
          setSelectedEventIdx(eventIdx);
        });
        
        // The route will be displayed by the useEffect that monitors selectedDayIdx/selectedEventIdx changes
      } else {
        // Regular single selection - clear multi-selection AND any displayed route
        console.log('📍 Non-route event selected, clearing multi-selection and routes');
        
        // Set clearing flag to prevent useEffect race condition
       if (isMultiSelectMode) {
        setIsClearing(true);
        
        setIsMultiSelectMode(false);
        setSelectedEvents(new Set());
       }
        setPreviousSelectedEvent(event);
        
        
        
        // Batch the state updates to prevent double useEffect triggers
        React.startTransition(() => {
          setSelectedDayIdx(dayIdx);
          setSelectedEventIdx(eventIdx);
          // Clear the clearing flag after state updates
          setTimeout(() => setIsClearing(false), 100);
        });
      }
    }
  }  // Helper to set a new date for the new day being added (take the last and add one)
  function setNewDateHelper() {
        let nextDate;
              if (trip.days && trip.days.length > 0) {
                const lastDay = trip.days[trip.days.length - 1].date;
                nextDate = new Date(lastDay);
                nextDate.setDate(nextDate.getDate() + 1);
              } else {
                nextDate = new Date();
              }
              return nextDate.toISOString().slice(0, 10);
  }

  // Handle route creation for selected events
  function handleCreateRoute() {
   // Get all selected events with their locations
    const eventsWithLocations = [];
    const selectedEventIds = Array.from(selectedEvents);
       
    // For each selected event ID, find the corresponding event and its position
    selectedEventIds.forEach(eventId => {
      let foundEvent = null;
      let foundDayIdx = -1;
      let foundEventIdx = -1;
      
      // Find the event in the trip data
      for (let dayIdx = 0; dayIdx < trip.days.length; dayIdx++) {
        const day = trip.days[dayIdx];
        for (let eventIdx = 0; eventIdx < day.events.length; eventIdx++) {
          const event = day.events[eventIdx];
          if (event._id === eventId) {
            foundEvent = event;
            foundDayIdx = dayIdx;
            foundEventIdx = eventIdx;
            break;
          }
        }
        if (foundEvent) break;
      }
      
      // Add to route if found and has valid location
      if (foundEvent && foundEvent.location && foundEvent.location.lat && foundEvent.location.lng) {
        console.log('📍 Including event in route:', foundEvent.description, eventId);
        eventsWithLocations.push({
          ...foundEvent,
          dayIdx: foundDayIdx,
          eventIdx: foundEventIdx
        });
      } else {
        console.log('⚠️ Selected event not found or missing location:', eventId);
      }
    });
    
    console.log('🔍 Events with locations for route:', eventsWithLocations.length, eventsWithLocations.map(e => e.description));
    
    if (eventsWithLocations.length < 2) {
      alert('Selected events must have valid locations to create a route.');
      return;
    }
    
    // Sort events by day and order within day for logical routing
    eventsWithLocations.sort((a, b) => {
      if (a.dayIdx !== b.dayIdx) return a.dayIdx - b.dayIdx;
      return (a.orderInDay || 0) - (b.orderInDay || 0);
    });
    
    // Create route points for the map
    const routePoints = eventsWithLocations.map(event => ({
      lat: event.location.lat,
      lng: event.location.lng,
      name: event.description || event.location.name || 'Unnamed location'
    }));
    
    console.log('Route points:', routePoints);
    
    // Store the route data for potential addition to trip
    setPendingRoute({
      routePoints,
      eventsWithLocations,
      startLocation: eventsWithLocations[0].location,
      endLocation: eventsWithLocations[eventsWithLocations.length - 1].location
    });
    
    // Call the map callback with route information
    if (searchMapCallback) {
      searchMapCallback('', null, null, null, false, routePoints);
    }
    
    // Show dialog to ask if user wants to add route to plan
    setShowRouteDialog(true);
  }

  // Handle adding route to trip plan
  function handleAddRouteToTrip() {
    if (!pendingRoute) return;
    
    const { routePoints, eventsWithLocations, startLocation, endLocation } = pendingRoute;
    
    // Determine which day to add the route to (use the first event's day)
    const targetDayIdx = eventsWithLocations[0].dayIdx;
    
    // Create route description
    const startName = eventsWithLocations[0].description || 'Start';
    const endName = eventsWithLocations[eventsWithLocations.length - 1].description || 'End';
    const routeDescription = `Route: ${startName} → ${endName}`;
    
    // Create route event with route object
    const routeEvent = {
      eventType: 'Route',
      description: routeDescription,
      location: null, // Routes don't have a single location, they have waypoints
      route: {
        waypoints: routePoints,
        startLocation: startLocation,
        endLocation: endLocation,
        travelMode: 'DRIVING', // Default to driving
        eventIds: eventsWithLocations.map(e => e._id) // Reference to connected events
      },
      longDescription: `Route connecting ${eventsWithLocations.length} locations: ${eventsWithLocations.map(e => e.description).join(' → ')}`
    };
    
    // Add the route event to the trip
    addEventToTrip(targetDayIdx, routeEvent);
    
    // Close dialog and clear selections
    setShowRouteDialog(false);
    setPendingRoute(null);
    setSelectedEvents(new Set());
    setIsMultiSelectMode(false);
    
    // Clear the route from map - it will only show when the route event is selected
    if (searchMapCallback) {
      // Show the day/trip overview instead of keeping the route visible
      if (trip && trip.countries && trip.countries.length > 0) {
        (async () => {
          const boundsOrCenter = await getCountriesBoundingBox(trip.countries, trip.cities);
          if (boundsOrCenter) {
            if (boundsOrCenter.bounds) {
              searchMapCallback('', boundsOrCenter.bounds, null, null, false, null);
            } else {
              searchMapCallback('', boundsOrCenter.lat, boundsOrCenter.lng, boundsOrCenter.zoom, false, null);
            }
          }
        })();
      }
    }
  }

  // Handle canceling route addition
  function handleCancelRoute() {
    setShowRouteDialog(false);
    setPendingRoute(null);
    // Clear the route from map and show trip overview
    setSelectedEvents(new Set());
    setIsMultiSelectMode(false);
    setPreviousSelectedEvent(null);
    
    // Clear the route from map
    if (searchMapCallback && trip && trip.countries && trip.countries.length > 0) {
      (async () => {
        const boundsOrCenter = await getCountriesBoundingBox(trip.countries, trip.cities);
        if (boundsOrCenter) {
          if (boundsOrCenter.bounds) {
            searchMapCallback('', boundsOrCenter.bounds, null, null, false, null);
          } else {
            searchMapCallback('', boundsOrCenter.lat, boundsOrCenter.lng, boundsOrCenter.zoom, false, null);
          }
        }
      })();
    }
  }

  // Drag and drop handler
  const handleDragEnd = async (result) => {
    if (!result.destination) return;

    const sourceIndex = result.source.index;
    const destIndex = result.destination.index;

    // Handle folder/day dragging
    if (result.type === 'folder' || result.source.droppableId === 'days-container') {
      if (sourceIndex === destIndex) return;

      const newTrip = { ...trip, days: [...trip.days] };
      const [movedDay] = newTrip.days.splice(sourceIndex, 1);
      newTrip.days.splice(destIndex, 0, movedDay);

      try {
        const updatedTrip = await updateTripOnBackend(newTrip);
        setTrip(updatedTrip);

        if (selectedDayIdx !== null) {
          let nextSelectedDayIdx = selectedDayIdx;

          if (selectedDayIdx === sourceIndex) {
            nextSelectedDayIdx = destIndex;
          } else if (sourceIndex < destIndex && selectedDayIdx > sourceIndex && selectedDayIdx <= destIndex) {
            nextSelectedDayIdx = selectedDayIdx - 1;
          } else if (sourceIndex > destIndex && selectedDayIdx >= destIndex && selectedDayIdx < sourceIndex) {
            nextSelectedDayIdx = selectedDayIdx + 1;
          }

          if (nextSelectedDayIdx !== selectedDayIdx) {
            React.startTransition(() => {
              setSelectedDayIdx(nextSelectedDayIdx);
            });
          }
        }
      } catch (err) {
        console.log('Failed to reorder folders: ' + err.message);
      }
      return;
    }

    const sourceDayId = result.source.droppableId;
    const destDayId = result.destination.droppableId;
/* code generated by chatgpt not sure why this guard is needed */
    if (!sourceDayId.startsWith('day-') || !destDayId.startsWith('day-')) {
      return;
    }

    // Parse day indices from droppableId (format: "day-0", "day-1", etc.)
    const sourceDayIdx = parseInt(sourceDayId.split('-')[1], 10);
    const destDayIdx = parseInt(destDayId.split('-')[1], 10);

    if (Number.isNaN(sourceDayIdx) || Number.isNaN(destDayIdx)) {
      return;
    }

    if (sourceDayIdx === destDayIdx && sourceIndex === destIndex) {
      return; // No change
    }

    const newTrip = { ...trip };
    const sourceDayEvents = [...newTrip.days[sourceDayIdx].events];
    
    // Get the event being moved
    const movedEvent = sourceDayEvents[sourceIndex];
    
    if (sourceDayIdx === destDayIdx) {
      // Moving within the same day - reorder events
      sourceDayEvents.splice(sourceIndex, 1);
      sourceDayEvents.splice(destIndex, 0, movedEvent);
      
      // Update orderInDay values for all events in this day
      sourceDayEvents.forEach((event, index) => {
        event.orderInDay = index + 1;
      });
      
      newTrip.days[sourceDayIdx].events = sourceDayEvents;
    } else {
      // Moving between different days
      const destDayEvents = [...newTrip.days[destDayIdx].events];
      
      // Remove from source day
      sourceDayEvents.splice(sourceIndex, 1);
      
      // Add to destination day
      destDayEvents.splice(destIndex, 0, movedEvent);
      
      // Update orderInDay values for source day
      sourceDayEvents.forEach((event, index) => {
        event.orderInDay = index + 1;
      });
      
      // Update orderInDay values for destination day
      destDayEvents.forEach((event, index) => {
        event.orderInDay = index + 1;
      });
      
      newTrip.days[sourceDayIdx].events = sourceDayEvents;
      newTrip.days[destDayIdx].events = destDayEvents;
    }

    // Sort events in all days to maintain consistency
    newTrip.days.forEach(day => {
      day.events.sort((a, b) => (a.orderInDay || 1) - (b.orderInDay || 1));
    });

    try {
      const updatedTrip = await updateTripOnBackend(newTrip);
      const sortedTrip = {
        ...updatedTrip,
        days: updatedTrip.days.map(day => ({
          ...day,
          events: day.events.sort((a, b) => (a.orderInDay || 1) - (b.orderInDay || 1))
        }))
      };
      setTrip(sortedTrip);
      
      // Update selection if the event moved to a different day
      if (sourceDayIdx !== destDayIdx && selectedEventIdx === sourceIndex && selectedDayIdx === sourceDayIdx) {
        // Batch the state updates to prevent double useEffect triggers
        React.startTransition(() => {
          setSelectedDayIdx(destDayIdx);
          setSelectedEventIdx(destIndex);
        });
      }
    } catch (err) {
      console.log('Failed to reorder events: ' + err.message);
      // Optionally revert the optimistic update on error
    }
  };

  return (
    <DragDropContext onDragEnd={handleDragEnd}>
      {showTutorial && (
        <TripPlanTreeTutorialModal
          onClose={handleCloseTutorial}
          dontShowChecked={dontShowChecked}
          setDontShowChecked={setDontShowChecked}
        />
      )}
      <RouteDialog
        isOpen={showRouteDialog}
        pendingRoute={pendingRoute}
        onAdd={handleAddRouteToTrip}
        onCancel={handleCancelRoute}
      />
      <EventMediaModal open={mediaModal.open} onClose={() => setMediaModal({ open: false, url: '', filename: '' })} mediaUrl={mediaModal.url} filename={mediaModal.filename} />
      <div className="trip-tree-root">
        <div className="tree-node">
          <span className="tree-folder-icon" onClick={() => setExpanded(e => !e)}>{expanded ? '▼' : '▶'}</span>
          <span className="tree-root-label" onClick={() => setExpanded(e => !e)}>
            {trip.tripName}{!isOwner ? " (Read Only)" : ""}
          </span>
          {isOwner && (
            <button id = "addFolderBtn" className="tree-add-folder-btn mini-btn" title="Add Day/Folder" onClick={e => { 
              e.stopPropagation(); 
              clearRoutesAndMultiSelection(); // Clear routes when adding day
              if (trip.fixedDates) {setNewDay({ date: setNewDateHelper(), description: '' });}
              setShowAddDay(s => !s); 
            }}
            >
              <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#DCEAD5"><path d="M580-340h40v-80h80v-40h-80v-80h-40v80h-80v40h80v80ZM184.62-200q-27.62 0-46.12-18.5Q120-237 120-264.62v-430.76q0-27.62 18.5-46.12Q157-760 184.62-760h199.23l80 80h311.53q27.62 0 46.12 18.5Q840-643 840-615.38v350.76q0 27.62-18.5 46.12Q803-200 775.38-200H184.62Zm0-40h590.76q10.77 0 17.7-6.92 6.92-6.93 6.92-17.7v-350.76q0-10.77-6.92-17.7-6.93-6.92-17.7-6.92H447.77l-80-80H184.62q-10.77 0-17.7 6.92-6.92 6.93-6.92 17.7v430.76q0 10.77 6.92 17.7 6.93 6.92 17.7 6.92ZM160-240v-480 480Z"/></svg>
            </button>
          )}
          {isMultiSelectMode && selectedEvents.size >= 1 && (() => {
            // Check if the currently selected single event (not in selectedEvents) is a route event
            const isCurrentEventRoute = trip && trip.days && 
              selectedDayIdx !== null && selectedEventIdx !== null &&
              trip.days[selectedDayIdx] && 
              trip.days[selectedDayIdx].events &&
              trip.days[selectedDayIdx].events[selectedEventIdx] &&
              trip.days[selectedDayIdx].events[selectedEventIdx].eventType === 'Route';
            
            console.log('🔍 Create Route button check:', {
              isCurrentEventRoute,
              selectedEventsSize: selectedEvents.size,
              selectedDayIdx,
              selectedEventIdx,
              currentEventType: trip?.days?.[selectedDayIdx]?.events?.[selectedEventIdx]?.eventType
            });
            
            // Don't show Create Route button if current selected event is a route event
            if (isCurrentEventRoute) {
              console.log('🚫 Hiding Create Route button - route event currently selected');
              return null;
            }
            
            return (
              <button 
                id="createRouteBtn" 
                className="tree-route-btn mini-btn" 
                title={`Create Route (${selectedEvents.size} events)`} 
                onClick={e => { 
                
                  e.stopPropagation(); 
                  e.preventDefault();
                  handleCreateRoute(); 
                }}
                style={{ 
                  position: 'relative', 
                  zIndex: 1000,
                  pointerEvents: 'auto',
                  cursor: 'pointer'
                }}
              >
                <svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 -960 960 960"  style={{ pointerEvents: 'none' }}>
                  <path d="M200-160q-33 0-56.5-23.5T120-240q0-33 23.5-56.5T200-320q33 0 56.5 23.5T280-240q0 33-23.5 56.5T200-160Zm560 0q-33 0-56.5-23.5T680-240q0-33 23.5-56.5T760-320q33 0 56.5 23.5T840-240q0 33-23.5 56.5T760-160ZM240-400v-80h360l-80-80 56-56 176 176-176 176-56-56 80-80H240Z"/>
                </svg>
              </button>
            );
          })()}
        </div>
        {isMultiSelectMode && (
          <div className="multi-select-info" style={{ 
            fontSize: '0.8em', 
            color: '#999', 
            marginTop: '4px', 
            textAlign: 'center' 
          }}>
            {selectedEvents.size} events selected • Press ESC to clear • Ctrl+click to select multiple
          </div>
        )}
        {showAddDay && (
          <div className="tree-add-form"
            tabIndex={-1}
            onKeyDown={e => { if (e.key === 'Escape') setShowAddDay(false); }}
          >
            {/* Only show date input if fixedDates is false */}
            {trip.fixedDates && (
              <input
                type="date"
                value={newDay.date}
                onChange={e => setNewDay(d => ({ ...d, date: e.target.value }))}
                onKeyDown={e => { if (e.key === 'Escape') setShowAddDay(false); }}
                autoFocus
              />
            )}
            <input
              id="newDayDescription"
              type="text"
              placeholder="Day description"
              value={newDay.description}
              onChange={e => setNewDay(d => ({ ...d, description: e.target.value }))}
              onKeyDown={e => { if (e.key === 'Escape') setShowAddDay(false); }}
              autoFocus={trip.fixedDates}
            />
            <button id="addDayBtn" className="tree-add-btn mini-btn" title="Save" onClick={handleAddDay} onKeyDown={e => { if (e.key === 'Escape') setShowAddDay(false); }}>✔</button>
            <button id="cancelAddDayBtn"className="tree-add-btn mini-btn" title="Cancel" onClick={e => setShowAddDay(false)} onKeyDown={e => { if (e.key === 'Escape') setShowAddDay(false); }}>X</button>
          </div>
        )}
        {expanded && (
          <Droppable droppableId="days-container" type="folder" isDropDisabled={!isOwner}>
            {(provided, snapshot) => (
              <div
                className={`tree-children ${snapshot.isDraggingOver ? 'dragging-over' : ''}`}
                ref={provided.innerRef}
                {...provided.droppableProps}
              >
                {trip.days.map((day, idx) => {
                  const canDragFolder = isOwner && selectedDayIdx === idx && selectedEventIdx === null && !isMultiSelectMode;
                  return (
                    <Draggable
                      key={day._id ? `folder-${day._id}` : `folder-${idx}`}
                      draggableId={day._id ? `folder-${day._id}` : `folder-${idx}`}
                      index={idx}
                      isDragDisabled={!canDragFolder}
                    >
                      {(folderProvided) => (
                        <div
                          ref={folderProvided.innerRef}
                          {...folderProvided.draggableProps}
                          style={{ ...folderProvided.draggableProps.style }}
                        >
                          <TreeDay
                          day={day}
                          onAddEvent={addEventToTrip}
                          dayIdx={idx}
                          setEditingEvent={setEditingEvent}
                          setEventEditMode={setEventEditMode} // <-- Pass the parent setter!
                          newEvent={newEventDayIdx === idx ? newEvent : undefined}
                          setNewEvent={ev => { setNewEvent(ev); setNewEventDayIdx(idx); }}
                          onMapIconClick={handleMapIconClick}
                          onEditDay={() => handleEditDay(idx)}
                          onDeleteDay={() => handleDeleteDay(idx)}
                          onEditEvent={eventIdx => handleEditEvent(idx, eventIdx) }
                          onDeleteEvent={eventIdx => handleDeleteEvent(idx, eventIdx)}
                          editingEvent={editingEvent}
                          onEditEventSave={handleEditEventSave}
                          onEditEventCancel={handleEditEventCancel}
                          onEditMapPicker={handleEditMapPicker}
                          setNewEventDayIdx={setNewEventDayIdx}
                          setNewEventForDay ={setNewEvent}
                          editingDayIdx={editingDayIdx}
                          editingDayValue={editingDayValue}
                          setEditingDayValue={setEditingDayValue}
                          fixedDates={trip.fixedDates} //
                          onEditDaySave={handleEditDaySave}
                          onEditDayCancel={handleEditDayCancel}
                          onAttachDocument={(eventIdx) => handleAttachDocument(idx, eventIdx)}
                          onEventDoubleClick={event => {
                            // Find the event in the latest trip state by _id
                            const backendEvent = trip.days
                              .flatMap(day => day.events)
                              .find(ev => ev._id && event._id && ev._id === event._id);
                            if (backendEvent && backendEvent.media) {
                              setMediaModal({ open: true, url: getEventMediaUrl(backendEvent), filename: backendEvent.media });
                            }}}
                          onAttachView={event => {
                            // Find the event in the latest trip state by _id
                            const backendEvent = trip.days
                              .flatMap(day => day.events)
                              .find(ev => ev._id && event._id && ev._id === event._id);
                            if (backendEvent && backendEvent.media) {
                              setMediaModal({ open: true, url: getEventMediaUrl(backendEvent), filename: backendEvent.media });
                            }}}
                          selectedEventIdx={selectedDayIdx === idx ? selectedEventIdx : null}
                          isSelected={selectedDayIdx === idx}
                          onSelectDay={() => {
                            // Cancel edit if currently editing
                            if (selectedDayIdx !== idx) {
                              if (editingEvent && editingEvent.dayIdx !== null && editingEvent.eventIdx !== null 
                                && (editingEvent.dayIdx !== idx )) {
                                handleEditEventCancel();
                              }
                              // Batch the state updates to prevent double useEffect triggers
                              React.startTransition(() => {
                                setSelectedDayIdx(idx);
                                setSelectedEventIdx(null);
                              });
                              setEditingDayIdx(null);
                            }}
                          }
                          onSelectEvent={(dIdx, eIdx, isCtrlClick) => {handleEventSelection(dIdx, eIdx, isCtrlClick); }}
                          userLayer={userLayer}
                          trip={trip}
                          isOwner={isOwner} // Pass to TreeEvent for per-event disables
                          isMultiSelectMode={isMultiSelectMode}
                          selectedEvents={selectedEvents}
                          clearRoutesAndMultiSelection={clearRoutesAndMultiSelection}
                          isMobile={isMobile}
                          folderDragHandleProps={canDragFolder ? folderProvided.dragHandleProps : undefined}
                          isFolderDraggable={canDragFolder}
                        />
                        </div>
                      )}
                    </Draggable>
                  );
                })}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        )}
      </div>
    </DragDropContext>
  );
}

//# sourceMappingURL=tripPlanTree.js.map


